<template>
    <div
        @click="toggleAccordion"
        :class="[
            {
                'open': accordionOpen,
            },
            `
                accordion-item
            `
        ]"
    >
        <div
            class="
                accordion-tab
            "
        >
            <i :class="[
                accordionOpen ? 'fa-minus' : 'fa-plus', 
                `
                    accordion-icon fas
                `
                ]"
            ></i>
            <span v-html="title" class="accordion-title" />
        </div>
        <transition name="fade">
            <div
                v-if="accordionOpen"
                class="accordion-inner"
            >
                <slot />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'accordion',
    props: {
        title: {
            required: true,
            type: String,
        },
        accordionOpen: {
            default: false,
            type: Boolean,
        },
    },
    methods: {
        toggleAccordion() {
            this.accordionOpen = !this.accordionOpen;
        },
    },
};
</script>

<style lang="scss" scoped>
    .accordion {
        &-item {
            display: block;
            width: 100%;
        }

        &-inner {
            padding: 1.5em;
        }

        &-tab {
            display: flex;
            align-items: center;
            width: 100%;
            padding: 0.5em 0.75em;
            color: $shamrock;
            cursor: pointer;
            border: 1px solid $gallery;
        }

        &-icon {
            font-size: 0.75em;
        }

        &-title {
            margin-left: 0.75em;
        }
    }
</style>
